'use client'

import { useEffect } from 'react'

/**
 * Fires a best-effort POST to /api/log-404 once on mount. The server decides
 * whether to log (rate limits, tenant lookup). Errors are swallowed — a log
 * failure must never break the 404 page.
 */
export default function NotFoundLogger() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    try {
      const body = JSON.stringify({
        path: window.location.pathname,
        referrer: document.referrer || null,
      })
      // Prefer sendBeacon so the request survives quick back-navigations.
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: 'application/json' })
        navigator.sendBeacon('/api/log-404', blob)
      } else {
        fetch('/api/log-404', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
          keepalive: true,
        }).catch(() => {})
      }
    } catch {
      // swallow
    }
  }, [])
  return null
}
